import SideBar from "../Components/SideBar";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { exportToExcel, exportToCSV } from "../../Utils/exportUtils";
import formatDate from "../../Components/dateFormatter";
import callNewsLetterApi from "../callApi/newsletter";


const ITEMS_PER_PAGE = 10;
export default function NewsLetter() {
  const [currentPage, setCurrentPage] = useState(0);
  const [usersData, setUsersData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    callNewsLetterApi().then((res) => {
    
      setUsersData(res);
    });
  }, []);



  const handleExportExcel = () => {
    exportToExcel(usersData, "newsletter"); 
  };

  const handleExportCSV = () => {
    exportToCSV(usersData, "newsletter"); 
  };

  const handlePageClick = (data) => {
    const selectedPage = data.selected;
    setCurrentPage(selectedPage);
  };

  const paginatedData = usersData.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE
  );

  return (
    <div className="admin-newsletter">
      <SideBar />
      <div className="admin-container">
        <div className="sec">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <h2>News Letter</h2>
          <div style={{ marginLeft: "auto" }}>
            <button className="save"  onClick={handleExportExcel}>
              Export to Excel
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button className="save"  onClick={handleExportCSV} >
              Export to CSV
            </button>
          </div>
        </div>
        <br />
        <table className="admin-newsletter-table">
          <tbody>
            <tr>
              <th className="newsletter-table-email">Email</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
            {Array.isArray(paginatedData) && paginatedData.length > 0 ? (
            paginatedData.map((item) => (
              <tr key={item.id}>
                {" "}
                <td>{item.Email}</td>
                <td>{formatDate(item.CreatedDate)}</td>
                <td>{item.Status}</td>
              </tr>
            ))
            ):(
              <tr>
                <td colSpan="5">No Record Found</td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="newsletterPagination">
        <ReactPaginate
          pageCount={Math.ceil(usersData.length / ITEMS_PER_PAGE)}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          subContainerClassName="pages pagination"
          activeClassName="active"
        />
        </div>
        </div>
      </div>
    </div>
  );
}
